import { NativeStackScreenProps } from '@react-navigation/native-stack';
import React from 'react';
import { useSelector } from 'react-redux';

import BecomeVipModal from '../Components/Modals/BecomeVipModal';
import VipTablesModal from '../Components/Modals/VipTablesModal';
import { RootStackParamList } from '../navigator';

type Props = NativeStackScreenProps<RootStackParamList, 'VipTables'>;

const VipTablesScreen: React.FC<Props> = ({ navigation }) => {
	const isVip = useSelector((s: any) => s.auth?.user?.isVip || false);

	return (
		<>
			{isVip ? (
				<VipTablesModal onClose={() => navigation.goBack()} />
			) : (
				<BecomeVipModal onClose={() => navigation.goBack()} />
			)}
		</>
	);
};

export default VipTablesScreen;
